import { apiGet, apiPut } from './client';
import type { Index4Fund, Index4FundRow, Index4FundSaveRequest } from '../types/Index4Fund';

// Tenant-scoped (X-Tenant-Id applied by the client).
export function getIndex4Funds(fundId: number): Promise<Index4Fund[]> {
  return apiGet<Index4Fund[]>(`/api/index4funds?fundId=${fundId}`);
}

// Replace the fund's WHOLE index set (server validates the weights sum to 100%).
export function saveIndex4Funds(fundId: number, rows: Index4FundRow[]): Promise<Index4Fund[]> {
  return apiPut<Index4FundSaveRequest, Index4Fund[]>(`/api/index4funds/${fundId}`, { rows });
}
